const SQRT3 = Math.sqrt(3);
/**
 * Pixel centre of a hex under `layout`. Movement-node positions are derived
 * from this (a node is the centroid of the three hexes that meet at it), so
 * this is the only place hex geometry is encoded.
 */
export function hexToPixel(layout, c) {
    const { size, origin } = layout;
    if (layout.orientation === "pointy") {
        return {
            x: origin.x + size * (SQRT3 * c.q + (SQRT3 / 2) * c.r),
            y: origin.y + size * (1.5 * c.r),
        };
    }
    return {
        x: origin.x + size * (1.5 * c.q),
        y: origin.y + size * ((SQRT3 / 2) * c.q + SQRT3 * c.r),
    };
}
/** Arithmetic mean of some points. */
export function pointAverage(points) {
    let x = 0;
    let y = 0;
    for (const p of points) {
        x += p.x;
        y += p.y;
    }
    const n = points.length || 1;
    return { x: x / n, y: y / n };
}
//# sourceMappingURL=layout.js.map